import { ThemeEditorComponent } from "./app/components/theme-editor/theme-editor.component";
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  importProvidersFrom,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  NavigationEnd,
  provideRouter,
  Router,
  RouterModule,
} from "@angular/router";
import { TranslocoModule, TranslocoService } from "@ngneat/transloco";
import { CommonModule, NgIf } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { NgxsModule, Select, StateStream, Store } from "@ngxs/store";
import { OnlineStoreState } from "./app/pages/store/store/store.state";
import { ProductsGuard } from "./app/pages/store/products.guard";
import { environment } from "./environments/environment";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { ProductResolver } from "./app/pages/store/product/product.resolver";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BehaviorSubject, firstValueFrom, Observable } from "rxjs";
import { LocalizationModule } from "./app/components/localization";
import { LocalSelectorComponent } from "./app/components/local-selector/local-selector.component";
import { SidebarService } from "./app/shared/services/sidebar.services";
import { DialogService } from "./app/shared/services/dialog.service";
import { DialogAnimation } from "./app/components/wrapper/wrapper.animation";
import { IconUventex } from "./assets/icons/uventex";
import { IconAAUxUventex } from "./assets/icons/aauxuventex";
import { SafeTypes } from "./app/shared/constants/safe-types.enum";
import { SafePipe } from "./app/shared/pipes/safe.pipe";
import { FooterComponent } from "./app/components/footer/footer.component";
import { StoreList } from "./app/store";
import { IconBars } from "./assets/icons/bars";
import { AuthTokenResolver } from "./app/pages/auth/authtoken.resolver";
import { HeaderComponent } from "./app/components/header/header.component";
import {
  FilterComponent,
  FilterType,
} from "./app/components/filter/filter.component";
import { SearchComponent } from "./app/components/search/search.component";
import { IconCalendar } from "./assets/icons/calendar";
import { IconLocation } from "./assets/icons/location";
import { IconSearch } from "./assets/icons/search";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDatepickerModule,
  MatDateRangePicker,
} from "@angular/material/datepicker";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import * as moment from "moment";
import { MatIconModule } from "@angular/material/icon";
import { LoaderInterceptor } from "./app/shared/http-interceptor/loader.interceptor";
import { AuthInterceptor } from "./app/shared/http-interceptor/auth.interceptor";
import { CarouselModule } from "ngx-owl-carousel-o";
import { DictionariesContract } from "./app/shared/contracts/dictionaries.contract";
import { UserState } from "./app/store/user/user.store";
import { User } from "./app/shared/models/user.model";
import { LoggedGuard } from "./app/common/guards/logged.guard";
import { EventRegistrationGuard } from "./app/common/guards/event-registration.guard";
import { WINDOW } from "@ng-web-apis/common";
import { EventsService } from "./app/shared/constants/events.service";
import { IsDashboard } from "./app/store/user/user.actions";
import { HomeBannerService } from "./app/shared/services/home-banner.service";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MobileFiltersDialogComponent } from "./app/components/mobile-filters-dialog/mobile-filters-dialog.component";
import { FilterService } from "./app/shared/services/filter.service";
import { ThemeService } from "./app/shared/constants/theme.service";
import { MatNativeDateModule } from "@angular/material/core";
import { HomeHeaderComponent } from "./app/components/home-header/home-header.component";
import { ApplicationService } from "./app/shared/constants/application.service";
import { GlobalLoaderComponent } from "./app/components/global-loader/global-loader.component";
import { EventRoleGuard } from "./app/common/guards/event-role.guard";

declare function setIntercomForSignInUser(
  name: string,
  id: number,
  email: string,
  createdAt: number,
  userHash: string
): void;
declare function setIntercomForNotSignInUser(): void;

interface LocationHistory {
  previousUrl: string | null;
  currentUrl: string | null;
}

const OWT_THEME_TOGGLE_KEY = "owtThemeToggle";

@Component({
  standalone: true,
  selector: "app-root",
  templateUrl: "./main.html",
  styleUrls: ["./main.scss"],
  imports: [
    RouterModule,
    CommonModule,
    ThemeEditorComponent,
    MatFormFieldModule,
    TranslocoModule,
    MatSelectModule,
    LocalizationModule,
    LocalSelectorComponent,
    ToastrModule,
    FooterComponent,
    SafePipe,
    NgIf,
    MatDialogModule,
    MobileFiltersDialogComponent,
    HeaderComponent,
    FilterComponent,
    SearchComponent,
    MatButtonModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    CarouselModule,
    MatNativeDateModule,
    HomeHeaderComponent,
    GlobalLoaderComponent,
  ],
  providers: [TranslocoService, DialogService],
  animations: DialogAnimation,
})
export class AppComponent implements OnInit, AfterViewInit {
  @Select(UserState.authUser)
  public authUser$!: Observable<User>;

  public openLeftPanel$ = new BehaviorSubject<boolean>(false);
  public mobileMenuButtom = new BehaviorSubject<any>(null);
  public IconUventex = IconUventex;
  public IconAAUxUventex = IconAAUxUventex;
  public IconBars = IconBars;
  public IconCalendar = IconCalendar;
  public IconLocation = IconLocation;
  public IconSearch = IconSearch;
  public SafeTypes = SafeTypes;
  public showFilters = false;
  public isSidePanelVisible = false;
  public fullWidth = false;
  public lat!: number;
  public lng!: number;
  public moment = moment;
  public countries: any;

  isDialogOpen = false;

  /*public sportsList = [
    {name: "Sport Karate"},
    {name: "Traditional Karate"},
    {name: "MMA"},
    {name: "Taekwondo"},
    {name: "Judo"},
    {name: "Jiujitsu"},
    {name: "Kickboxing"},
    {name: "Tang Soo Do"},
  ];*/
  public router!: string;
  public hidePanelsOnOpenSearch!: boolean;
  public isDiffUrl!: boolean;

  @ViewChild("sidebarComponentOutletRight", {
    read: ViewContainerRef,
    static: true,
  })
  private sidebarComponentOutletRight!: ViewContainerRef;

  @ViewChild("dialogComponentOutlet", { read: ViewContainerRef, static: true })
  private dialogComponentOutlet!: ViewContainerRef;
  showJoinBanner: boolean = false;

  @HostBinding("@parentPopupWindow")
  public get isHasDialog(): boolean {
    return Boolean(
      this.dialogComponentOutlet && this.dialogComponentOutlet.length
    );
  }

  @ViewChild("menuBtn", { static: false })
  private set menuButton(menuButton: ElementRef<HTMLElement>) {
    if (menuButton) {
      this.mobileMenuButtom.next(menuButton.nativeElement);
    }
  }

  @ViewChild("picker") picker!: MatDateRangePicker<any>;
  @ViewChild("location") location!: ElementRef<HTMLElement>;
  @ViewChild("desktopSearchField")
  private desktopSearchField!: ElementRef<HTMLInputElement>;

  protected readonly FilterType = FilterType;

  private locationHistory: LocationHistory = {
    previousUrl: null,
    currentUrl: null,
  };

  public range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  public isDashboard = false;
  public isAAUReads = false;
  public isAAULookupTool = false;

  firstTimeLoad: boolean = true;

  filtersApplied = false;

  aauSubdomain: boolean | null = null;
  owtmaSubdomain = false;
  isAdmin = false;
  themeEditorOpen = false;
  themeEditorChanges = 0;
  private isOwtSubdomain = false;
  private subdomainInfoLoaded = false;
  isLoading = true;

  constructor(
    @Inject(WINDOW) readonly windowRef: Window,
    private dictionariesContract: DictionariesContract,
    private sidebarService: SidebarService,
    private dialogService: DialogService,
    private themeService: ThemeService,
    private dialog: MatDialog,
    public filterService: FilterService,
    private _router: Router,
    private eventsService: EventsService,
    public homeBanner: HomeBannerService,
    private applicationService: ApplicationService,
    private store: Store
  ) {
    this.themeService.applyUventexTheme();
    _router.events.subscribe((r) => {
      if (r instanceof NavigationEnd) {
        this.showJoinBanner = false;

        // Subdomain themes style some pages dark (routes configured in ThemeService)
        this.themeService.updateForRoute(r.urlAfterRedirects);

        if (
          r.url === "/" ||
          r.url === "/forgot-password" ||
          r.url === "/signup" ||
          r.url === "/aau" ||
          r.url === "/membership/login"
        ) {
          this.showJoinBanner = true;
        }

        //if (r.url === "/meets" || r.url === "/copy-past-even" || r.url.indexOf("registration") >= 0) {
        if (
          r.url === "/" ||
          r.url === "/events" ||
          // r.url.indexOf("/events/event") > -1 ||
          r.url === "/hub-studios" ||
          r.url === "/memberships" ||
          r.url === "/athletes"
        ) {
          this.showFilters = true;
        } else {
          this.showFilters = false;
        }

        if (r.url.indexOf("dashboard") >= 0) {
          this.isDashboard = true;
          this.openSidePanel();
          //this.fullWidth = true;
        } else {
          this.isDashboard = false;
          this.closeSidePanel();
        }
        if (r.url.indexOf("aau-reads") >= 0) {
          this.isAAUReads = true;
        } else {
          this.isAAUReads = false;
        }

        if (r.url.indexOf("aau-lookup") >= 0) {
          this.isAAULookupTool = true;
        } else {
          this.isAAULookupTool = false;
        }

        this.store.dispatch(new IsDashboard(this.isDashboard));

        window.dispatchEvent(new Event("resize"));
        if (this.firstTimeLoad) {
          this.firstTimeLoad = false;
        } else {
          this.homeBanner.showJoinBanner$.next(false);
        }
        window.scrollTo(0, 0);
      }
    });

    this.authUser$.subscribe((user) => {
      if (user) {
        const now = new Date();
        const userId = user.studioAccount
          ? user.studioAccount.id
          : user.eventAccount
            ? user.eventAccount.id
            : 0;

        /*
        setIntercomForSignInUser(
          user.fullName,
          +user.intercomUserId,
          user.email,
          now.getTime(),
          user.intercomHash
        );
        */

        this.store.dispatch(new IsDashboard(this.isDashboard));
      } else {
        /*
        setIntercomForNotSignInUser();
        */
      }
    });

    /*_router.events.subscribe((r) => {
      if (r instanceof NavigationEnd) {
        this.locationHistory.previousUrl = this.locationHistory.currentUrl;
        this.locationHistory.currentUrl = r.url;

        if (this.locationHistory.previousUrl && (this.locationHistory.previousUrl !== this.locationHistory.currentUrl)) {
          this.windowRef.location.reload();
        }
      }
    })*/
  }

  // Admins flip the OWT theme by triple-clicking the navbar logo; the choice is kept in localStorage
  onLogoClick(event: MouseEvent) {
    if (!this.isAdmin || event.detail !== 3) {
      return;
    }
    const enabled = !this.owtmaSubdomain;
    localStorage.setItem(OWT_THEME_TOGGLE_KEY, String(enabled));
    this.setOwtTheme(enabled);
  }

  private applyOwtThemeToggle() {
    if (!this.subdomainInfoLoaded) {
      return;
    }
    const saved = localStorage.getItem(OWT_THEME_TOGGLE_KEY);
    this.setOwtTheme(this.isAdmin && saved !== null ? saved === "true" : this.isOwtSubdomain);
  }

  private setOwtTheme(enabled: boolean) {
    if (this.owtmaSubdomain === enabled) {
      return;
    }
    this.owtmaSubdomain = enabled;
    this.applicationService.owtmaSubdomain$.next(enabled);
    if (enabled) {
      this.themeService.setSubdomainTheme("owtma");
      this.homeBanner.showJoinBanner$.next(false);
    } else {
      this.themeService.clearSubdomainTheme();
      if (this.aauSubdomain) {
        this.themeService.applyAAUTheme();
      }
    }
  }

  public async ngOnInit() {
    this.isLoading = true;
    window.addEventListener("scroll", this.onScroll, true);

    this.store.select(UserState.isAdmin).subscribe((isAdmin) => {
      this.isAdmin = !!isAdmin;
      this.applyOwtThemeToggle();
    });

    this.filterService.filters$.subscribe((v) => {
      if (
        v.countryIds.length > 0 ||
        v.leagueIds.length > 0 ||
        v.sportIds.length > 0
      ) {
        this.filtersApplied = true;
      } else {
        this.filtersApplied = false;
      }
    });

    try {
      const response: any = await firstValueFrom(
        this.applicationService.getInfo()
      );
      if (
        response.subdomain &&
        response.isSubdomain &&
        response.subdomain === "aau"
      ) {
        this.applicationService.aauSubdomain$.next(true);
        this.aauSubdomain = true;
      } else {
        this.applicationService.aauSubdomain$.next(false);
        this.aauSubdomain = false;
      }
      if (this.aauSubdomain) {
        this.themeService.applyAAUTheme();
        this.homeBanner.showJoinBanner$.next(false);
      }

      if (
        response.subdomain &&
        response.isSubdomain &&
        response.subdomain === "usag"
      ) {
        this.applicationService.usagSubdomain$.next(true);
      } else {
        this.applicationService.usagSubdomain$.next(false);
      }

      if (
          response.subdomain &&
          response.isSubdomain &&
          response.subdomain === "jkf"
      ) {
        this.applicationService.jkfSubdomain$.next(true);
      } else {
        this.applicationService.jkfSubdomain$.next(false);
      }

      if (
        response.subdomain &&
        response.isSubdomain &&
        response.subdomain === "owt"
      ) {
        this.isOwtSubdomain = true;
        this.applicationService.owtmaSubdomain$.next(true);
        this.owtmaSubdomain = true;
        this.themeService.setSubdomainTheme("owtma");
        this.homeBanner.showJoinBanner$.next(false);
      } else {
        this.applicationService.owtmaSubdomain$.next(false);
        this.owtmaSubdomain = false;
      }

      this.applicationService.isSubdomain$.next(!!response.isSubdomain);
      this.applicationService.subdomainLeagueIds$.next(
        response.isSubdomain && Array.isArray(response.leagueIds)
          ? response.leagueIds
          : []
      );
    } catch (e) {
      console.error(e);
      this.applicationService.subdomainLeagueIds$.next([]);
    } finally {
      this.subdomainInfoLoaded = true;
      this.applyOwtThemeToggle();
      this.isLoading = false;
    }
  }

  showScrollTopButton = false;

  onScroll = (event?: Event): void => {
    const header = document.getElementById("mainHeader");
    let scrollY = window.scrollY || document.documentElement.scrollTop;

    // Fallback for inner container scrolling if needed
    if (event && event.target) {
      const target = event.target as HTMLElement;
      if (target.scrollTop !== undefined && target !== document.documentElement && target !== document.body) {
        scrollY = Math.max(scrollY, target.scrollTop);
      }
    }

    if (scrollY > 0) {
      header?.classList.add("scrolled");
    } else {
      header?.classList.remove("scrolled");
    }

    if (scrollY > window.innerHeight) {
      this.showScrollTopButton = true;
    } else {
      this.showScrollTopButton = false;
    }
  };



  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const outlet = document.querySelector('.outlet');
    if (outlet) {
      outlet.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const rightBlock = document.querySelector('.right-block');
    if (rightBlock) {
      rightBlock.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  openFiltersMobile() {
    this.isDialogOpen = true;
  }

  closeDialog() {
    this.isDialogOpen = false;
  }

  public ngAfterViewInit(): void {
    this.sidebarService.setSidebarContainer(
      this.sidebarComponentOutletRight,
      "right"
    );
    this.dialogService.setDialogContainer(this.dialogComponentOutlet);

    this.dictionariesContract.getCountries().subscribe((countries) => {
      this.countries = countries.map((i: any) => i.name);
      this.dictionariesContract.completeCountries = countries;
    });

    if (document.location.href.includes("diff")) this.isDiffUrl = true;
  }

  public toggleLeftPanel(): void {
    const next = !this.openLeftPanel$.value;
    this.openLeftPanel$.next(next);
  }

  public closeLeftPanel(): void {
    this.openLeftPanel$.next(false);
  }

  public leftPanelClickOutside(isOwn: any) {
    if (!isOwn) {
      this.closeLeftPanel();
    }
  }

  public displaySearch(event: boolean) {
    this.hidePanelsOnOpenSearch = event;
    this.homeBanner.showJoinBanner$.next(false);
  }

  public displayMobilSearch(event: boolean) {
    this.homeBanner.showJoinBanner$.next(false);
  }

  public getCoords() {
    const successCallback = (position: any) => {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
    };

    const errorCallback = (error: any) => {
      console.log(error);
    };

    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
  }

  public openPicker() {
    this.picker.open();
  }

  public search() { }

  openSidePanel() {
    this.isSidePanelVisible = true;
    //this.store.dispatch(new ToggleSidePanel(true));
  }

  closeSidePanel() {
    this.isSidePanelVisible = false;
    //this.store.dispatch(new ToggleSidePanel(false));
  }
}

const policies = environment.policiesLinks as {
  key: string;
  external: string;
  route: string;
  label: string;
}[];

const policiesRoutes = policies.map((el) => ({
  path: el.route.replace("/", ""),
  loadComponent: () =>
    import("src/app/pages/home/new-home/new-home.component").then(
      (m) => m.NewHomeComponent
    ),
}));

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(LocalizationModule),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAnimations(),
    ProductsGuard,
    Store,
    provideHttpClient(
      withInterceptors([
        (req, next) => {
          return next(req);
        },
      ]),
      withInterceptorsFromDi()
    ),
    importProvidersFrom(
      ToastrModule.forRoot({
        preventDuplicates: true,
        autoDismiss: true,
        // positionClass: "toast-top-center",
      }),
      NgxsModule.forRoot(StoreList, {
        developmentMode: !environment.production,
      })
    ),
    provideRouter([
      {
        path: "award-ceremony/:eventId/presenter",
        loadComponent: () =>
          import("src/app/pages/award-ceremony-presenter/award-ceremony-presenter.component").then(
            (m) => m.AwardCeremonyPresenterComponent
          ),
      },
      {
        path: "store/list",
        loadComponent: () =>
          import(
            "src/app/pages/store/products-list/products-list.component"
          ).then((m) => m.ProductsListComponent),
        providers: [
          //Store,
          StateStream,
          importProvidersFrom(NgxsModule.forFeature([OnlineStoreState])),
        ],
        canActivate: [ProductsGuard],
      },
      {
        path: "store/product/:studioId/:categoryId",
        loadComponent: () =>
          import("src/app/pages/store/product/product.component").then(
            (m) => m.UvProductComponent
          ),
        resolve: { data: ProductResolver },
        providers: [
          //Store,
          StateStream,
          ProductResolver,
          importProvidersFrom(NgxsModule.forFeature([OnlineStoreState])),
        ],
      },
      {
        path: "store/cart",
        loadComponent: () =>
          import("src/app/pages/cart/cart.component").then(
            (m) => m.UvCartComponent
          ),
      },
      {
        path: "forgot-password",
        loadComponent: () =>
          import("src/app/pages/home/new-home/new-home.component").then(
            (m) => m.NewHomeComponent
          ),
        children: [],
      },
      {
        path: "signup",
        loadComponent: () =>
          import("src/app/pages/home/new-home/new-home.component").then(
            (m) => m.NewHomeComponent
          ),
        children: [],
      },
      {
        path: "auth-jws/token/:token",
        loadComponent: () =>
          import("src/app/pages/auth/auth.component").then(
            (m) => m.AuthComponent
          ),
        resolve: { data: AuthTokenResolver },
        providers: [AuthTokenResolver],
      },
      {
        path: "events",
        loadComponent: () =>
          import("src/app/pages/home/events/events.component").then(
            (m) => m.EventsComponent
          ),
      },
      {
        path: "rankings",
        loadComponent: () =>
          import("src/app/pages/home/rankings/rankings.component").then(
            (m) => m.RankingsComponent
          ),
      },
      {
        path: "events/event/:eventId",
        loadComponent: () =>
          import("src/app/pages/home/event/event.component").then(
            (m) => m.EventComponent
          ),
      },
      {
        path: "events/event/:eventId/medals",
        loadComponent: () =>
          import("src/app/pages/home/medals/medals.component").then(
            (m) => m.MedalsComponent
          ),
      },
      // {
      //   path: "events/event/:eventId/standings",
      //   loadComponent: () =>
      //     import("src/app/pages/home/standings/standings.component").then(
      //       (m) => m.StandingsComponent
      //     ),
      // },
      {
        path: "event/:eventId/registration",
        loadComponent: () =>
          import(
            "src/app/pages/default-registration/default-registration.component"
          ).then((m) => m.DefaultRegistrationComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "event/:eventId/registration/new",
        loadComponent: () =>
          import(
            "src/app/pages/default-registration/default-registration.component"
          ).then((m) => m.DefaultRegistrationComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "event/:eventId/registration/:personId",
        loadComponent: () =>
          import(
            "src/app/pages/default-registration/default-registration.component"
          ).then((m) => m.DefaultRegistrationComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "hub-studios",
        loadComponent: () =>
          import("src/app/pages/home/hub-studios/hub-studios.component").then(
            (m) => m.HubStudiosComponent
          ),
      },
      {
        path: "hub-studios/studio/:studioId",
        loadComponent: () =>
          import("src/app/pages/home/studio/studio.component").then(
            (m) => m.StudioComponent
          ),
      },
      {
        path: "hub-studios/studio/:studioId/diff",
        loadComponent: () =>
          import("src/app/pages/home/studio/studio.component").then(
            (m) => m.StudioComponent
          ),
      },
      // {
      //   path: 'tv',
      //   loadComponent: () => import('src/app/pages/home/tv/tv.component').then(m => m.TvComponent),
      // },
      {
        path: "athletes",
        loadComponent: () =>
          import("src/app/pages/athletes/athletes.component").then(
            (m) => m.AthletesComponent
          ),
      },
      {
        path: "athletes/:id",
        loadComponent: () =>
          import("src/app/pages/athlete/athlete.component").then(
            (m) => m.AthleteComponent
          ),
      },
      ...policiesRoutes,
      {
        path: "leagues",
        loadComponent: () =>
          import("src/app/pages/leagues/leagues.component").then(
            (m) => m.LeaguesComponent
          ),
      },
      {
        path: "verification-insurance",
        loadComponent: () =>
          import(
            "src/app/components/aau-verification-insurance/aau-verification-insurance.component"
          ).then((m) => m.AAUVerificationInsuranceComponent),
      },
      {
        path: "pm/view",
        loadComponent: () =>
          import(
            "src/app/pages/check-membership/check-membership.component"
          ).then((m) => m.CheckMembershipComponent),
      },
      {
        path: "memberships",
        loadComponent: () =>
          import("src/app/pages/memberships/memberships.component").then(
            (m) => m.MembershipsComponent
          ),
      },
      {
        path: "applications",
        loadComponent: () =>
          import("src/app/pages/memberships/memberships.component").then(
            (m) => m.MembershipsComponent
          ),
      },
      {
        path: "memberships/aau",
        loadComponent: () =>
          import("src/app/pages/memberships/memberships.component").then(
            (m) => m.MembershipsComponent
          ),
      },
      {
        path: "meets",
        loadComponent: () =>
          import("src/app/pages/meet-page/meet-page.component").then(
            (m) => m.MeetPageComponent
          ),
      },
      {
        path: "create-event",
        loadComponent: () =>
          import("src/app/pages/create-event/create-event.component").then(
            (m) => m.CreateEventComponent
          ),
      },
      {
        path: "create-new-event",
        loadComponent: () =>
          import(
            "src/app/pages/create-event/new-event/new-event.component"
          ).then((m) => m.NewEventComponent),
      },
      {
        path: "create-event/new-event/:eventId",
        loadComponent: () =>
          import(
            "src/app/pages/create-event/new-event/new-event.component"
          ).then((m) => m.NewEventComponent),
      },
      {
        path: "assisted-registration/:eventId/officials", // for official / volunteer / referee / coach
        loadComponent: () =>
          import("src/app/pages/registration/official/registration-official.component")
            .then((m) => m.RegistrationOfficialComponent),
        canActivate: [EventRegistrationGuard, EventRoleGuard],
        data: { isAssisted: true, roles: ["Promoter", "Registration", "Sub-Promoter"], roleMode: "any" },
      },
      {
        path: "assisted-registration/:eventId/athletes",
        loadComponent: () =>
          import("src/app/pages/registration/registration.component").then(
            (m) => m.RegistrationComponent
          ),
        canActivate: [EventRegistrationGuard, EventRoleGuard],
        data: { isAssisted: true, roles: ["Promoter", "Registration", "Sub-Promoter"], roleMode: "any" },
        // componentless children keep RegistrationComponent alive while editing a profile
        children: [
          { path: "", children: [] },
          { path: "new", children: [] },
          { path: ":personId", children: [] },
        ],
      },
      {
        path: "buy-tickets/:eventId",
        loadComponent: () => import("src/app/pages/registration/registration.component").then(m => m.RegistrationComponent),
        canActivate: [EventRegistrationGuard],
        data: { flow: "tickets" },
      },
      {
        path: "registration/:eventId",
        loadComponent: () =>
          import("src/app/pages/registration/registration.component").then(
            (m) => m.RegistrationComponent
          ),
        canActivate: [EventRegistrationGuard],
        // componentless children keep RegistrationComponent alive while editing a profile
        children: [
          { path: "", children: [] },
          { path: "new", children: [] },
          { path: ":personId", children: [] },
        ],
      },
      {
        path: "registration/:eventId/subevent/:subEventId",
        loadComponent: () =>
          import("src/app/pages/registration/registration.component").then(
            (m) => m.RegistrationComponent
          ),
        canActivate: [EventRegistrationGuard],
        children: [
          { path: "", children: [] },
          { path: "new", children: [] },
          { path: ":personId", children: [] },
        ],
      },
      {
        path: "registration-official/:eventId",
        loadComponent: () =>
          import(
            "src/app/pages/registration/official/registration-official.component"
          ).then((m) => m.RegistrationOfficialComponent),
        canActivate: [EventRegistrationGuard],
      },
      {
        path: "registration-volunteer/:eventId",
        loadComponent: () =>
          import(
            "src/app/pages/registration/official/registration-official.component"
          ).then((m) => m.RegistrationOfficialComponent),
        canActivate: [EventRegistrationGuard],
      },
      {
        path: "registration-referee/:eventId",
        loadComponent: () =>
          import(
            "src/app/pages/registration/official/registration-official.component"
          ).then((m) => m.RegistrationOfficialComponent),
        canActivate: [EventRegistrationGuard],
      },
      {
        path: "registration-coach/:eventId",
        loadComponent: () =>
          import(
            "src/app/pages/registration/official/registration-official.component"
          ).then((m) => m.RegistrationOfficialComponent),
        canActivate: [EventRegistrationGuard],
      },
      {
        path: "compliance/policy-exception/:uuid",
        loadComponent: () =>
          import(
            "src/app/components/aau-policy-exception/aau-policy-exception.component"
          ).then((m) => m.AAUPolicyExceptionComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "aau-lookup",
        loadComponent: () =>
          import("src/app/components/aau-lookup/aau-lookup.component").then(
            (m) => m.AAULookupComponent
          ),
        // canActivate: [LoggedGuard],
      },
      {
        path: "actions/membership/auto-renew/opt-out",
        loadComponent: () =>
          import(
            "src/app/pages/cancel-auto-renew/cancel-auto-renew.component"
          ).then((m) => m.CancelAutoRenewComponent),
      },
      {
        path: "membership",
        loadComponent: () =>
          import(
            "src/app/pages/registration/membership/membership.component"
          ).then((m) => m.MembershipComponent),
        canActivate: [LoggedGuard],
        children: [
          {
            path: ":eventId/persons",
            loadComponent: () => import("./app/pages/registration/membership/membership-persons/membership-persons.component").then(m => m.MembershipPersonsComponent),
          },
          {
            path: ":eventId/find-membership",
            loadComponent: () => import("./app/pages/registration/membership/membership-find/membership-find.component").then(m => m.MembershipFindComponent),
          },
          {
            path: ":eventId/bulk-upload",
            loadComponent: () => import("./app/pages/registration/membership/membership-bulk-upload/membership-bulk-upload.component").then(m => m.MembershipBulkUploadComponent),
          },
          {
            path: ":eventId/new-person",
            loadComponent: () => import("./app/pages/registration/membership/membership-person-edit/membership-person-edit.component").then(m => m.MembershipPersonEditComponent),
          },
          {
            path: ":eventId/edit-person/:personId",
            loadComponent: () => import("./app/pages/registration/membership/membership-person-edit/membership-person-edit.component").then(m => m.MembershipPersonEditComponent),
          },
          {
            path: ":eventId/choose-memberships",
            loadComponent: () => import("./app/pages/registration/membership/membership-choose-type/membership-choose-type.component").then(m => m.MembershipChooseTypeComponent),
          },
          {
            path: ":eventId/terms",
            loadComponent: () => import("./app/pages/registration/membership/membership-terms-sign/membership-terms-sign.component").then(m => m.MembershipTermsSignComponent),
          },
          {
            path: ":eventId/shopping-cart",
            loadComponent: () => import("./app/pages/registration/membership/membership-shopping-cart/membership-shopping-cart.component").then(m => m.MembershipShoppingCartComponent),
          },
          {
            path: ":eventId/verification",
            loadComponent: () => import("./app/pages/registration/membership/membership-verification/membership-verification.component").then(m => m.MembershipVerificationComponent),
          },
          {
            path: ":eventId/age-certification",
            loadComponent: () => import("./app/pages/registration/membership/membership-age-certification/membership-age-certification.component").then(m => m.MembershipAgeCertificationComponent),
          },
          {
            path: ":eventId/child-photo-consent",
            loadComponent: () => import("./app/pages/registration/membership/membership-child-photo/membership-child-photo.component").then(m => m.MembershipChildPhotoComponent),
          },
          {
            path: ":eventId/orders",
            loadComponent: () => import("./app/pages/registration/membership/membership-order-summary/membership-order-summary.component").then(m => m.MembershipOrderSummaryComponent),
          },
          {
            path: ":eventId/clubs",
            loadComponent: () => import("./app/pages/registration/membership/membership-club/membership-club-list/membership-club-list.component").then(m => m.MembershipClubListComponent),
          },
          {
            path: ":eventId/edit-club/:clubId",
            loadComponent: () => import("./app/pages/registration/membership/membership-club/membership-club-edit/membership-club-edit.component").then(m => m.MembershipClubEditComponent),
          },
          {
            path: ":eventId/club-persons",
            loadComponent: () => import("./app/pages/registration/membership/membership-club/membership-club-persons/membership-club-persons.component").then(m => m.MembershipClubPersonsComponent),
          },
          {
            path: ":eventId/club-agreement",
            loadComponent: () => import("./app/pages/registration/membership/membership-club/membership-club-agreement/membership-club-agreement.component").then(m => m.MembershipClubAgreementComponent),
          },
          {
            path: ":eventId/club-pre-app",
            loadComponent: () => import("./app/pages/registration/membership/membership-club/membership-club-pre-app/membership-club-pre-app.component").then(m => m.MembershipClubPreApplicationComponent),
          },
          {
            path: ":eventId/club-info",
            loadComponent: () => import("./app/pages/registration/membership/membership-club/membership-club-info/membership-club-info.component").then(m => m.MembershipClubInfoComponent),
          },

          {
            path: ":eventId/event-licensing-find",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-find/membership-event-licensing-find.component").then(m => m.MembershipEventLicensingFindComponent),
          },
          {
            path: ":eventId/event-licensing-information",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-information/membership-event-licensing-information.component").then(m => m.MembershipEventLicensingInformationComponent),
          },
          {
            path: ":eventId/event-licensing-agreement",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-agreement/membership-event-licensing-agreement.component").then(m => m.MembershipEventLicensingAgreementComponent),
          },
          {
            path: ":eventId/event-licensing-general-info",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-general-info/membership-event-licensing-general-info.component").then(m => m.MembershipEventLicensingGeneralInfoComponent),
          },
          {
            path: ":eventId/event-licensing-dashboard",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-dashboard/membership-event-licensing-dashboard.component").then(m => m.MembershipEventLicensingDashboardComponent),
          },
          {
            path: ":eventId/event-licensing-director",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-director/membership-event-licensing-director.component").then(m => m.MembershipEventLicensingDirectorComponent),
          },
          {
            path: ":eventId/event-licensing-facilities",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-facilities/membership-event-licensing-facilities.component").then(m => m.MembershipEventLicensingFacilitiesComponent),
          },
          {
            path: ":eventId/event-licensing-age-groups",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-age-groups/membership-event-licensing-age-groups.component").then(m => m.MembershipEventLicensingAgeGroupsComponent),
          },
          {
            path: ":eventId/event-licensing-flyer",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-event-flyer/membership-event-licensing-event-flyer.component").then(m => m.MembershipEventLicensingEventFlyerComponent),
          },
          {
            path: ":eventId/event-licensing-final-agreement",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-final-agreement/membership-event-licensing-final-agreement.component").then(m => m.MembershipEventLicensingFinalAgreementComponent),
          },
          {
            path: ":eventId/event-licensing-final-review",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-final-review/membership-event-licensing-final-review.component").then(m => m.MembershipEventLicensingFinalReviewComponent),
          },
          {
            path: ":eventId/practice-license-find",
            loadComponent: () => import("./app/pages/registration/membership/membership-practice-license-find/membership-practice-license-find.component").then(m => m.MembershipPracticeLicenseFindComponent),
          },
          {
            path: ":eventId/practice-license-clubs",
            loadComponent: () => import("./app/pages/registration/membership/membership-practice-license-clubs/membership-practice-license-clubs.component").then(m => m.MembershipPracticeLicenseClubsComponent),
          },
          {
            path: ":eventId/practice-license-download-certificates",
            loadComponent: () => import("./app/pages/registration/membership/membership-pract-lic-down-certs/membership-pract-lic-down-certs.component").then(m => m.MembershipPracticeLicenseDownloadCertificatesComponent),
          },
          {
            path: ":eventId/event-license-download-certificates",
            loadComponent: () => import("./app/pages/registration/membership/membership-event-licensing-download-certificates/membership-event-licensing-download-certificates.component").then(m => m.MembershipEventLicenseDownloadCertificatesComponent),
          },
          {
            path: ":eventId/practice-license-insurance",
            loadComponent: () => import("./app/pages/registration/membership/membership-practice-license-insurance/membership-practice-license-insurance.component").then(m => m.MembershipPracticeLicenseInsuranceComponent),
          },
          {
            path: ":eventId/practice-license-facilities",
            loadComponent: () => import("./app/pages/registration/membership/membership-practice-license-facilities/membership-practice-license-facilities.component").then(m => m.MembershipPracticeLicenseFacilitiesComponent),
          },
          {
            path: ":eventId/practice-license-final-review",
            loadComponent: () => import("./app/pages/registration/membership/membership-practice-license-final-review/membership-practice-license-final-review.component").then(m => m.MembershipPracticeLicenseFinalReviewComponent),
          },
        ],
      },
      {
        path: "bulk-verify",
        loadComponent: () =>
          import("src/app/components/bulk-verify/bulk-verify.component").then(
            (m) => m.BulkVerifyComponent
          ),
        canActivate: [LoggedGuard],
      },
      {
        path: "dashboard",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
        canActivate: [LoggedGuard],
      },
      {
        path: "dashboard/event/:eventId/settings/kpnp-integration",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
        canActivate: [LoggedGuard],
      },
      {
        path: "dashboard/memberships/compliance/discipline-info/:id",
        loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "dashboard/event-licenses/event-setup/:id",
        loadComponent: () => import("./app/components/event-licenses-event-setup/event-licenses-event-setup.component").then(m => m.EventLicensesEventSetupComponent),
        canActivate: [LoggedGuard],
        children: [
          {
            path: "details",
            loadComponent: () => import("./app/components/event-licenses-event-setup/event-license-event-setup-details/event-license-event-setup-details.component").then(m => m.EventLicensesEventSetupDetailsComponent),
          },
          { path: "setup", loadComponent: () => import("./app/components/event-licenses-event-setup/event-license-event-setup-step/event-license-event-setup-step.component").then(m => m.EventLicensesEventSetupStepComponent) },
          { path: "**", loadComponent: () => import("./app/components/event-licenses-event-setup/event-license-event-setup-template/event-license-event-setup-template.component").then(m => m.EventLicensesEventSetupTemplateComponent) },
        ],
      },
      {
        path: "dashboard/flights/:eventId",
        loadComponent: () =>
          import(
            "src/app/components/schedule-and-flights/schedule-and-flights.component"
          ).then((m) => m.ScheduleAndFlightsComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "tnt/schedule/:eventId",
        loadComponent: () =>
          import(
            "src/app/components/schedule-and-flights/schedule-and-flights.component"
          ).then((m) => m.ScheduleAndFlightsComponent),
        data: { mode: 'public' }
      },
      {
        path: "dashboard/standings/:eventId",
        loadComponent: () =>
          import("src/app/components/standings/standings.component").then(
            (m) => m.StandingsComponent
          ),
        canActivate: [LoggedGuard],
      },
      {
        path: "tnt/standings/:eventId",
        loadComponent: () =>
          import("src/app/components/standings/standings.component").then(
            (m) => m.StandingsComponent
          ),
        data: { mode: 'public' }
      },
      {
        path: "dashboard/memberships/api-request/:id",
        loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "dashboard/memberships/compliance/policy-exception/:uuid",
        loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "dashboard/schedule/:eventId",
        loadComponent: () =>
          import(
            "src/app/components/event-athlete-list/event-athlete-list.component"
          ).then((m) => m.EventAthleteListComponent),
        canActivate: [LoggedGuard],
      },
      {
        path: "tnt/competitors/:eventId",
        loadComponent: () =>
          import(
            "src/app/components/event-athlete-list/event-athlete-list.component"
          ).then((m) => m.EventAthleteListComponent),
        data: { mode: 'public' }
      },
      {
        path: "dashboard/event",
        canActivate: [LoggedGuard],
        children: [
          {
            path: "management",
            loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
            children: [
              {
                path: "schedule",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
            ],
          },
          {
            path: "reports",
            loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
            children: [
              {
                path: "finance",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "competitor",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "results",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "school",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "medical",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "staff",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "print",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "registration-official-report",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "clicker-log",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
            ],
          },
          {
            path: "settings",
            loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
            children: [
              {
                path: "staff-management",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
            ],
          },
        ],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/event/:eventId/management/areas",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/components/areas-management/areas-management.component").then(
            (m) => m.AreasManagementComponent
          ),
      },
      {
        path: "dashboard/event/:eventId/management/staff-credentials",
        canActivate: [LoggedGuard],
        loadComponent: () =>
            import("src/app/components/staff-credentials/staff-credentials.component").then(
                (m) => m.StaffCredentialsComponent
            ),
      },
      {
        path: "dashboard/event/:eventId/management/staff",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/components/staff-management/staff-management.component").then(
            (m) => m.StaffManagementComponent
          ),
      },
      {
        path: "dashboard/event/:eventId/reports/finance/financial-report",
        canActivate: [EventRegistrationGuard],
        loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
      },
      {
        path: "dashboard/event/:eventId/reports/competitor/v2",
        canActivate: [EventRegistrationGuard],
        loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
      },
      {
        path: "dashboard/event/:eventId",
        canActivate: [LoggedGuard],
        children: [
          {
            path: "management",
            loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
            children: [
              {
                path: "schedule",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "medic-info",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "award-ceremony",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
            ],
          },
          {
            path: "reports",
            loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
            children: [
              {
                path: "finance",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "competitor",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "results",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "school",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "medical",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "staff",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "print",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "registration-official-report",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "clicker-log",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
            ],
          },
          {
            path: "settings",
            loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
            children: [
              {
                path: "staff-management",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
              },
              {
                path: "editor",
                loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
                children: [
                  {
                    path: "files",
                    loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
                  },
                ],
              },
            ],
          },
        ],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/admin",
        canActivate: [LoggedGuard],
        children: [
          { path: "accounts", loadComponent: () => import('./app/pages/dashboard-cont/dashboard-cont.component').then(m => m.DashboardContComponent) },
          { path: "white-label", loadComponent: () => import("./app/pages/white-label-settings/white-label-settings.component").then(m => m.WhiteLabelSettingsComponent) },
          {
            path: "finances",
            loadComponent: () => import("./app/pages/dashboard-cont/dashboard-cont.component").then(m => m.DashboardContComponent),
            children: [
              { path: "performance", loadComponent: () => import('./app/pages/dashboard-cont/dashboard-cont.component').then(m => m.DashboardContComponent) },
            ],
          },
        ],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/league/:leagueId",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/reports",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/reports/payouts",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/reports/auto-renewal",
        canActivate: [LoggedGuard],
        loadComponent: () =>
            import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
                (m) => m.DashboardContComponent
            ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/reports/district-age",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management/members/athletes",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management-usagr/members/athletes",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/members/athletes/:option/:personId/:membershipId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/members/athletes/:option/:personId/:membershipId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management/members/non-athletes/:option/:personId/:membershipId",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management-usagr/members/non-athletes/:option/:personId/:membershipId",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/members/athletes/history/:personId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/members/athletes/history/:personId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/clubs",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/clubs",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/clubs/:option/:clubId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/clubs/:option/:clubId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/clubs/transfer/:clubId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/clubs/transfer/:clubId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/clubs/history/:clubId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/clubs/history/:clubId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management/ev-license/history/:evLicId",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management-usagr/ev-license/history/:evLicId",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/ev-license/edit/:evLicId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/ev-license/edit/:evLicId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/ev-license",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/ev-license",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/practice-license/history/:pracLicId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/practice-license/history/:pracLicId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management/practice-license/edit/:pracLicId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/management-usagr/practice-license/edit/:pracLicId",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management/members/practice-license",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management-usagr/members/practice-license",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/athlete/memberships",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/athlete/memberships/orders",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/non-athlete/memberships",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/account-holder",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/non-athlete/memberships/orders",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/memberships/management",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
        children: [
          {
            path: "**",
            loadComponent: () =>
              import(
                "src/app/pages/dashboard-cont/dashboard-cont.component"
              ).then((m) => m.DashboardContComponent),
          },
        ],
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships/reports/sports-age",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        canActivate: [LoggedGuard],
        path: "dashboard/memberships",
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "dashboard/league",
        canActivate: [LoggedGuard],
        loadComponent: () =>
          import("src/app/pages/dashboard-cont/dashboard-cont.component").then(
            (m) => m.DashboardContComponent
          ),
      },
      {
        path: "judge-assignment",
        loadComponent: () =>
          import("src/app/pages/judge/judge-assignment.component").then(
            (m) => m.JudgeAssignmentComponent
          ),
      },
      {
        path: "",
        loadComponent: () =>
          import("src/app/pages/home/new-home/new-home.component").then(
            (m) => m.NewHomeComponent
          ),
        children: [],
      },
      {
        path: "aau",
        loadComponent: () =>
          import("src/app/pages/home/new-home/new-home.component").then(
            (m) => m.NewHomeComponent
          ),
        children: [],
      },
      {
        path: "membership/login",
        loadComponent: () =>
          import("src/app/pages/home/new-home/new-home.component").then(
            (m) => m.NewHomeComponent
          ),
        children: [],
      },
      {
        path: "aau-reads",
        loadComponent: () =>
          import("src/app/pages/landings/aau-reads/aau-reads.component").then(
            (m) => m.AauReadsComponent
          ),
        children: [],
      },
      {
        path: "public/schedule/:eventId",
        loadComponent: () =>
          import("src/app/components/public-schedule/public-schedule.component").then(
            (m) => m.PublicScheduleComponent
          ),
        children: [],
      },
      {
        path: "public/competitors-report/:eventId",
        loadComponent: () =>
          import("src/app/components/competitors-report-public/competitors-report-public.component").then(
            (m) => m.CompetitorsReportPublicComponent
          ),
        children: [],
      },
      {
        path: "public/standings-report/:eventId",
        loadComponent: () =>
          import("src/app/components/standings-report-public/standings-report-public.component").then(
            (m) => m.StandingsReportPublicComponent
          ),
        children: [],
      },
      {
        path: "**",
        loadComponent: () =>
          import("src/app/pages/notfound-page/notfound.component").then(
            (m) => m.NotFoundComponent
          ),
      },
    ]),
  ],
});
